import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Flex,
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import CheckboxController from 'components/Form/CheckboxController';
import InputController from 'components/Form/InputController';
import { toast } from 'components/Toast';
import { ModalType } from 'constants/common';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useCreateBrandingMutation, useUpdateBrandingMutation } from 'services/branding';
import { BrandingFormValidate } from 'utils/validation';

const CreateBrandingModel = ({ isOpen, onClose, brandingDetail, refetch }) => {
  const cancelRef = React.useRef();
  const createBrandingMutation = useCreateBrandingMutation();
  const updateBrandingMutation = useUpdateBrandingMutation();
  const { control, handleSubmit, reset, setValue } = useForm({
    resolver: yupResolver(BrandingFormValidate),
    defaultValues: {
      name: '',
      isActive: false,
    },
  });

  useEffect(() => {
    if (brandingDetail) {
      reset({ name: brandingDetail.name, isActive: brandingDetail.isActive, id: brandingDetail._id });
    }
  }, [brandingDetail]);

  const handleSuccess = () => {
    toast.showMessageSuccess(`${brandingDetail ? 'Cập nhật' : 'Tạo'} Thương Hiệu thành công`);
    refetch?.();
    onClose(ModalType.Add);
  };

  const onSubmit = async values => {
    if (brandingDetail) {
      updateBrandingMutation.mutate(
        { name: values?.name, brandingId: brandingDetail?._id },
        {
          onSuccess: () => {
            handleSuccess();
          },
          onError: error => handleError(error),
        }
      );
    } else {
      createBrandingMutation.mutate(
        { ...values },
        {
          onSuccess: () => handleSuccess(),
          onError: error => handleError(error),
        }
      );
    }
  };
  return (
    <>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={() => {
          onClose(ModalType.Add);
        }}
        isOpen={isOpen}
        isCentered
      >
        <AlertDialogOverlay />
        <AlertDialogContent maxW={'600px'} maxH={'400px'}>
          <AlertDialogHeader textTransform="uppercase">{brandingDetail ? 'Cập nhật' : 'Tạo'} Branding</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            <InputController control={control} name="name" label="Tên Thương Hiệu" />
            {/* <InputController control={control} name="isActive" label="Đang Hoạt Động" type="checkbox" /> */}
            {/* <Flex>
              <CheckboxController control={control} name="isActive" label="Kích hoạt" />
            </Flex> */}
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={() => {
                onClose(ModalType.Add);
              }}
            >
              Hủy
            </Button>
            <Button
              colorScheme="blue"
              ml={3}
              isLoading={createBrandingMutation.isPending || updateBrandingMutation.isPending}
              onClick={handleSubmit(onSubmit)}
            >
              {brandingDetail ? 'Cập nhập' : 'Tạo'}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
export default CreateBrandingModel;
